import STATUS from '../status';
export default {
  props: {
    status: Number,
    result: Object,
    color: String
  },
  computed: {
    isComplete() {
      return this.status === STATUS.IMPORT_SUCCESS;
    }

  }
};